import { useEffect, useState, useRef } from 'react';

export default function Timer({ minute = 3, onEnd }) {
  const [secondsLeft, setSecondsLeft] = useState(minute * 60);
  const intervalRef = useRef(null);

  useEffect(() => {
    setSecondsLeft(minute * 60);
  }, [minute]);

  useEffect(() => {
    if (secondsLeft <= 0) {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (onEnd) onEnd();
      return;
    }
    intervalRef.current = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [secondsLeft]);

  const minutes = String(Math.floor(secondsLeft / 60)).padStart(2, '0');
  const seconds = String(secondsLeft % 60).padStart(2, '0');

  return (
    <span>
      {minutes}:{seconds}
    </span>
  );
}
